import { memo, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { announcementSelector } from "appredux/selectors";

const ServerUpdateNotice = () => {
  const { t } = useTranslation();
  const announcement = useSelector(announcementSelector);

  // Pengumuman berasal dari data init (`announcement`), berupa string.
  const message = typeof announcement === "string" ? announcement.trim() : "";

  // Dismiss disimpan di memori saja (tidak persist) → tiap refresh banner
  // tampil lagi. Disimpan per-isi-pesan agar pengumuman baru tetap muncul
  // walau pengumuman sebelumnya sempat ditutup di sesi yang sama.
  const [dismissedMessage, setDismissedMessage] = useState("");
  const dismissed = !!message && dismissedMessage === message;

  if (!message || dismissed) {
    return null;
  }

  return (
    <Alert
      banner
      type="warning"
      style={{ backgroundColor: "rgb(255, 239, 179)" }}
      message={message}
      closable={{
        closeIcon: <CloseOutlined />,
        "aria-label": t("topBar.serverUpdateNotice.close"),
      }}
      onClose={() => setDismissedMessage(message)}
    />
  );
};

export default memo(ServerUpdateNotice);
